import type { XmlPathNodePredicate } from '../xml/xml-field-key-map.flatten';
import type { Hl7ObrObxLocateMeta } from '../hl7/hl7-field-key-map.flatten';

/** One selectable XML field from field-key-map-xml.json (flattened). */
export interface XmlFieldOption {
  /** Internal map key (may include values[] cartesian prefix). */
  key: string;
  /** Shown in Field input / autocomplete label column. */
  label: string;
  /** Autocomplete row when different from `label`. */
  listLabel?: string;
  path: string;
  leaf: string;
  isRepeatable?: boolean;
  repeatableNodes?: string[];
  nodePredicates?: XmlPathNodePredicate[];
}

export interface XmlFieldMapMeta {
  path: string;
  displayKey?: string;
  isRepeatable?: boolean | string;
  repeatableNodes?: string[];
  nodePredicates?: XmlPathNodePredicate[];
}

/** User-facing field name: cartesian map key when present (e.g. `TC.TestGrossing.…`). */
/** HL7 segment or dotted field option from field-key-map-hl7.json. */
export interface Hl7FieldOption {
  key: string;
  label: string;
  path: string;
  leaf: string;
  isRepeatable?: boolean;
  hl7ObrObxLocate?: Hl7ObrObxLocateMeta;
}

export interface Hl7FieldMapMeta {
  path: string;
  isRepeatable?: boolean | string;
  repeatableNodes?: string[];
  hl7ObrObxLocate?: Hl7ObrObxLocateMeta;
}

export function hl7FieldOptionDisplayLabel(opt: Hl7FieldOption | null | undefined): string {
  if (!opt) {
    return '';
  }
  return (opt.label || opt.key || '').trim();
}

export function xmlFieldOptionDisplayLabel(opt: XmlFieldOption | null | undefined): string {
  if (!opt) {
    return '';
  }
  return (opt.listLabel || opt.key || opt.label || '').trim();
}
